import { getAwsAssets } from "@src/utils/index";
import { t } from "i18next";
import { Image } from "@src/components/Image";
import React from "react";
import styles from "../styles/Announcements.module.scss";

const NoContentScreen = () => {
  return (
    <div className={styles.noContentScreen}>
      <Image
        src={getAwsAssets("MegaphoneIcon.svg", "Overview")}
        alt="noContentScreenThumbnail"
        height={140}
        width={140}
      />
      <h4>
        {t(
          "components.tabs.announcements.components.noContentScreen.noAnnoucementsHeading",
          "No annoucements here"
        )}
      </h4>
      <p>
        {t(
          "components.tabs.announcements.components.noContentScreen.noAnnoucementsText",
          "You don’t have any announcement to display here"
        )}
      </p>
    </div>
  );
};

export default NoContentScreen;
